import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermValue } from '../../../packages/JsonQuery';

export const selectIncludeNewMoscow = createSelector(selectJsonQuery, jsonQuery =>
  getTermValue('include_new_moscow')(jsonQuery),
);
